import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { PvDialog } from './PvDialog';

export const DeleteItemConfirmModal = ({
  onConfirm,
  isOpen,
  onClose,
  deleteType,
  headerText = `Are you sure you want to delete this ${deleteType}?`,
  bodyText = `This action cannot be undone.`,
}) => (
  <PvDialog
    onConfirm={onConfirm}
    title={headerText}
    open={isOpen}
    onClose={onClose}
    closeButtonText="Cancel"
  >
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography>{bodyText}</Typography>
        </Grid>
      </Grid>
    </Box>
  </PvDialog>
);
